/* KW Device Picker — ES2018, no deps: search, brand>series>model, memory, detection */
(function () {
'use strict';
var IOS = { '430x932@3': '16 Plus,15 Plus,15 Pro Max,14 Pro Max', '440x956@3': '16 Pro Max,17 Pro Max', '402x874@3': '16 Pro,17 Pro,17',
  '393x852@3': '16,15,15 Pro,14 Pro', '390x844@3': '14,13,13 Pro,12,12 Pro', '428x926@3': '14 Plus,13 Pro Max,12 Pro Max',
  '375x812@3': '13 mini,12 mini,11 Pro,XS,X', '414x896@2': '11,XR', '414x896@3': '11 Pro Max,XS Max',
  '375x667@2': 'SE (2020/2022),SE 2022,SE 2020,8,7', '414x736@3': '8 Plus,7 Plus' };
var BRANDS = /^(samsung|apple|google|xiaomi|huawei|motorola|oneplus|sony|oppo|honor|nothing|amazon|garmin)/;
var KEY = 'kw_device';

function ga(el, a) { return el.getAttribute(a); }
function norm(s) {
  s = String(s || '').toLowerCase().replace(/\+/g, 'plus').replace(/[^a-z0-9]+/g, '');
  return s.replace(BRANDS, '') || s;
}
function words(s) {
  var out = [];
  String(s || '').toLowerCase().replace(/\+/g, ' plus ').split(/[^a-z0-9]+/).forEach(function (w) {
    if (!w) return;
    out.push(w);
    var m = /^([a-z]{3,})(\d+)$/.exec(w); /* fold6 -> fold, 6 */
    if (m) out.push(m[1], m[2]);
  });
  return out;
}
/* Only same-origin relative paths may ever be navigated to or written into an href. */
function safe(u) { return typeof u === 'string' && u.charAt(0) === '/' && u.charAt(1) !== '/' ? u : ''; }
function esc(s) {
  return String(s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}
function track(ev, data) {
  window.dataLayer = window.dataLayer || [];
  data.event = ev;
  window.dataLayer.push(data);
}
function readDevice() {
  try {
    var raw = localStorage.getItem(KEY), m;
    if (!raw && (m = document.cookie.match(/(?:^|;\s*)kw_device=([^;]+)/))) raw = decodeURIComponent(m[1]);
    var d = raw ? JSON.parse(raw) : null;
    return d && d.n && safe(d.u) ? d : null;
  } catch (e) { return null; }
}
function cookie(v, age) {
  try {
    document.cookie = KEY + '=' + v + ';max-age=' + age + ';path=/;SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
  } catch (e) {}
}
function saveDevice(d) {
  var s = JSON.stringify(d);
  try { localStorage.setItem(KEY, s); } catch (e) {}
  cookie(encodeURIComponent(s), 31536000);
}
function clearDevice() {
  try { localStorage.removeItem(KEY); } catch (e) {}
  cookie('', 0);
}
function enc(s) { return encodeURIComponent(String(s || '')).replace(/%20/g, '+'); }
/* Cases-first destination: model pages are case pages already; Boost URLs get the Produktart filter. */
function casesUrl(d) {
  var u = safe(d && d.u);
  if (!u) return '';
  if (u.indexOf('?') === -1) return u;
  if (d.cat && d.cat !== 'smartphone') return u;
  return '/collections/smartphone?pf_t_produktart=Produktart%3AH%C3%BCllen&pf_t_modell=Modell%3A' + enc(d.t || d.n);
}
/* Everything for the device: the Boost model filter across all products. */
function allUrl(d) {
  var u = safe(d && d.u);
  if (!u) return '';
  if (u.indexOf('pf_t_modell=') > -1 || (d.cat && d.cat !== 'smartphone')) return u;
  return '/collections/alle-produkte?pf_t_hersteller=Hersteller%3A' + enc(d.h || d.brand) + '&pf_t_modell=Modell%3A' + enc(d.t || d.n);
}
var NOCASE = '&pf_t_produktart=Produktart%3ADisplayschutz&pf_t_produktart=Produktart%3AHalterungen+und+St%C3%A4nder&pf_t_produktart=Produktart%3ASonstiges';
/* Accessories without cases: brand OR universal (Boost ORs values inside one filter only), Produktart minus Huellen. */
function accUrl(d) {
  if (d.cat && d.cat !== 'smartphone') {
    return '/collections/alle-produkte?pf_t_hersteller=Hersteller%3A' + enc(d.h || d.brand) + '&pf_t_hersteller=Hersteller%3AUniversell' + NOCASE + '&sort=best-selling';
  }
  /* brand OR universal. Modell:Universell exists as a tag but is not reliably in Boost's capped Modell filter. */
  return '/collections/alle-produkte?pf_t_hersteller=Hersteller%3A' + enc(d.h || d.brand) + '&pf_t_hersteller=Hersteller%3AUniversell&pf_t_gerat=Ger%C3%A4t%3ASmartphone' + NOCASE + '&sort=best-selling';
}
function remember(m, method) {
  saveDevice({ n: m.n, u: m.u, brand: m.brand, cat: m.cat, t: m.t || '', h: m.h || '', ts: Date.now() });
  track('kw_picker_complete', { brand: m.brand, model: m.n, method: method });
}
function link(cls, m, act) {
  return '<a class="' + cls + '" href="' + esc(m.u) + '" data-kw-act="' + act + '" data-kw-v="' + m.i + '">';
}

function Picker(root) {
  var self = this;
  this.root = root; this.t = {};
  try { this.t = JSON.parse(ga(root, 'data-i18n')); } catch (e) {}
  this.detect = ga(root, 'data-detect') === 'true';
  this.q = function (sel) { return root.querySelector(sel); };
  this.input = this.q('[data-kw-input]');
  this.results = this.q('[data-kw-results]');
  this.clearBtn = this.q('[data-kw-clear]');
  this.brands = this.q('[data-kw-brands]');
  this.brandsHTML = this.brands.innerHTML;
  this.panel = this.q('[data-kw-panel]');
  this.cats = this.q('[data-kw-cats]');
  this.rem = this.q('[data-kw-remembered]');
  this.det = this.q('[data-kw-detect]');
  this.cat = 'smartphone';
  this.index = [];
  this.active = -1;
  this.mode = ga(root, 'data-kw-mode') || 'section';
  this.readyCbs = [];

  var load = function () { self.load(); };
  ['focusin', 'pointerenter', 'touchstart'].forEach(function (ev) {
    root.addEventListener(ev, load, { once: true, passive: true });
  });
  if (this.mode !== 'header') { if (window.requestIdleCallback) requestIdleCallback(load, { timeout: 2500 }); else setTimeout(load, 2500); }

  this.input.addEventListener('input', function () {
    self.start();
    self.clearBtn.hidden = !self.input.value;
    clearTimeout(self.timer);
    self.timer = setTimeout(function () { self.search(); }, 60);
  });
  this.input.addEventListener('keydown', function (e) { self.onKey(e); });
  this.input.addEventListener('focus', function () { if (self.input.value) self.search(); });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) self.close(); });
  this.results.addEventListener('mousedown', function (e) { e.preventDefault(); }); /* keep the combobox focused */
  root.addEventListener('focusout', function (e) {
    if (e.relatedTarget && root.contains(e.relatedTarget)) return;
    setTimeout(function () { if (!root.contains(document.activeElement)) self.close(); }, 150);
  });
  root.addEventListener('click', function (e) { self.onClick(e); });
  if (this.mode !== 'header') this.showRemembered();
}

var P = Picker.prototype;

P.onReady = function (cb) {
  if (this.data) return cb();
  this.readyCbs.push(cb);
  this.load();
};

P.onClick = function (e) {
  var el = e.target.closest('[data-kw-act],[data-kw-cat],[data-kw-brand],[data-kw-clear],[data-kw-i],.kwdp__res--empty');
  if (!el) return;
  this.start();
  var act = ga(el, 'data-kw-act'), v = ga(el, 'data-kw-v');
  if (el.hasAttribute('data-kw-cat')) return this.setCat(ga(el, 'data-kw-cat'));
  if (el.hasAttribute('data-kw-clear')) { this.input.value = ''; el.hidden = true; this.close(); return this.input.focus(); }
  if (el.hasAttribute('data-kw-i')) { e.preventDefault(); return this.complete(this.index[+ga(el, 'data-kw-i')], 'search'); }
  if (el.classList.contains('kwdp__res--empty')) { this.close(); return this.brands.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  if (el.hasAttribute('data-kw-brand')) {
    var b = this.data && this.findBrand(ga(el, 'data-kw-brand'));
    if (!b || !(b.series && b.series.length)) return; /* no data yet or brand-only entry: follow the link */
    e.preventDefault();
    return this.openBrand(b);
  }
  if (act === 'back') this.closePanel();
  else if (act === 'series') { this.series = v; this.renderPanel(); }
  else if (act === 'model') { e.preventDefault(); this.complete(this.index[+v], el.closest('[data-kw-detect]') ? 'detect' : 'browse'); }
  else if (act === 'other') { this.det.hidden = true; this.input.focus(); }
  else if (act === 'forget') { clearDevice(); this.rem.hidden = true; this.input.focus(); this.runDetection(); }
  else if (act === 'go') { var d = readDevice(); if (d) track('kw_picker_complete', { brand: d.brand, model: d.n, method: 'remembered' }); }
};

P.start = function () {
  if (this.started) return;
  this.started = true;
  track('kw_picker_start', {});
  this.load();
};

P.load = function () {
  var self = this;
  if (this.loading || this.data) return;
  this.loading = true;
  var cl = this.root.classList;
  cl.add('is-loading');
  fetch(ga(this.root, 'data-map-url'), { credentials: 'omit' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (json) {
      self.data = json;
      self.buildIndex();
      cl.remove('is-loading');
      cl.add('is-ready');
      if (self.input.value) self.search();
      self.runDetection();
      var cbs = self.readyCbs; self.readyCbs = [];
      cbs.forEach(function (f) { try { f(); } catch (e) {} });
    })
    .catch(function () { self.loading = false; cl.remove('is-loading'); });
};

P.buildIndex = function () {
  var idx = [], i = 0;
  (this.data.cats || []).forEach(function (cat) {
    (cat.brands || []).forEach(function (b) {
      var bn = words(b.n);
      (b.series || []).forEach(function (s) {
        (s.models || []).forEach(function (m) {
          if (!m.n || !safe(m.u)) return;
          var al = m.a || [];
          idx.push({
            i: i++, n: m.n, u: m.u, t: m.t || '', h: m.h || '', brand: b.n, cat: cat.id, nn: norm(m.n), an: al.map(norm),
            w: words(m.n).concat(bn, words(al.join(' ')))
          });
        });
      });
    });
  });
  this.index = idx;
};

function scoreToken(m, tok) {
  if (m.w.indexOf(tok) > -1) return 4;
  var num = /^\d+$/.test(tok); /* "5" must not prefix-match "5g" */
  for (var i = 0; i < m.w.length; i++) if (m.w[i].indexOf(tok) === 0 && !(num && /\D/.test(m.w[i]))) return 3;
  if (m.nn.indexOf(tok) === 0) return 3;
  if (tok.length < 4) return 0; /* short tokens must start a word: "xyz" must not hit galaXYZ fold */
  if (m.nn.indexOf(tok) > -1) return 1; /* "16" must not hit the 16 inside code A2160 */
  for (i = 0; i < m.an.length; i++) if (m.an[i].indexOf(tok) > -1) return 1;
  return 0;
}

P.find = function (query, max) {
  var toks = words(query).map(function (t) { return norm(t) || t; });
  if (!toks.length) return [];
  var joined = norm(query), out = [];
  for (var k = 0; k < this.index.length; k++) {
    var m = this.index[k], score = 0, j;
    for (j = 0; j < toks.length; j++) {
      var s = scoreToken(m, toks[j]);
      if (!s) break;
      score += s;
    }
    if (j < toks.length) continue;
    if (m.nn === joined || m.an.indexOf(joined) > -1) score += 8;
    else if (m.nn.indexOf(joined) === 0) score += 4;
    out.push([score, m]);
  }
  out.sort(function (a, b) { return b[0] - a[0] || a[1].nn.length - b[1].nn.length || a[1].i - b[1].i; });
  return out.slice(0, max).map(function (x) { return x[1]; });
};

P.search = function () {
  var q = this.input.value.trim(), self = this;
  if (!q) return this.close();
  if (!this.data) return;
  track('kw_picker_search', { query: q });
  var hits = this.find(q, 8), html = '';
  var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '|') + ')', 'i');
  var hl = function (name) {
    return name.split(re).map(function (part, k) { return k % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part); }).join('');
  };
  if (!hits.length) {
    html = '<li class="kwdp__res kwdp__res--empty" role="option" aria-selected="false" id="' + this.rid(0) + '">' + esc(this.t.noHits) + '</li>';
  }
  hits.forEach(function (m, i) {
    html += '<li class="kwdp__res" role="option" aria-selected="false" id="' + self.rid(i) + '" data-kw-i="' + m.i + '">' +
      '<a class="kwdp__res-link" href="' + esc(m.u) + '" tabindex="-1"><span class="kwdp__res-brand">' + esc(m.brand) +
      '</span><span class="kwdp__res-name">' + hl(m.n) + '</span></a></li>';
  });
  this.results.innerHTML = html;
  this.hits = hits;
  this.active = -1;
  this.results.hidden = false;
  this.input.setAttribute('aria-expanded', 'true');
};

P.rid = function (i) { return this.results.id + '-' + i; };

P.close = function () {
  var r = this.results, i = this.input;
  r.hidden = true; r.innerHTML = ''; i.setAttribute('aria-expanded', 'false'); i.removeAttribute('aria-activedescendant'); this.active = -1;
};

P.onKey = function (e) {
  var open = !this.results.hidden, n = this.hits ? this.hits.length : 0;
  if (e.key === 'Escape') { if (open) { e.preventDefault(); this.close(); } return; }
  if (e.key === 'Enter') {
    if (!open || !n) return;
    e.preventDefault();
    return this.complete(this.hits[this.active < 0 ? 0 : this.active], 'search');
  }
  if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
  if (!open) { if (this.input.value && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) this.search(); return; }
  if (!n) return;
  e.preventDefault();
  if (e.key === 'Home') this.active = 0;
  else if (e.key === 'End') this.active = n - 1;
  else this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + n) % n;
  var items = this.results.children;
  for (var i = 0; i < items.length; i++) items[i].setAttribute('aria-selected', i === this.active);
  this.input.setAttribute('aria-activedescendant', this.rid(this.active));
};

P.complete = function (m, method) {
  if (!m || !safe(m.u)) return;
  remember(m, method);
  location.href = this.mode === 'header' ? (casesUrl(m) || m.u) : m.u;
};

P.setCat = function (id) {
  this.cat = id;
  var btns = this.cats.querySelectorAll('[data-kw-cat]');
  for (var i = 0; i < btns.length; i++) {
    var on = ga(btns[i], 'data-kw-cat') === id;
    btns[i].classList.toggle('is-active', on);
    btns[i].setAttribute('aria-checked', on);
  }
  this.closePanel();
  if (!this.data) return;
  var html = '';
  if (id !== 'smartphone') {
    var cat = this.catData(id);
    (cat ? cat.brands : []).forEach(function (b) {
      html += '<a class="kwdp__chip" href="' + esc(safe(b.u) || '/collections/kompatibel-marken') + '" data-kw-brand="' + esc(b.n) + '">' + esc(b.n) + '</a>';
    });
  }
  this.brands.innerHTML = html || this.brandsHTML;
};

P.catData = function (id) {
  return (this.data.cats || []).filter(function (c) { return c.id === id; })[0];
};

P.findBrand = function (name) {
  var b, key = String(name || '').toLowerCase(), cats = this.data.cats || [], cur = this.catData(this.cat);
  var pick = function (c) { return c && (b = (c.brands || []).filter(function (x) { return String(x.n).toLowerCase() === key; })[0]); };
  pick(cur) || cats.some(pick);
  return b || null;
};

P.openBrand = function (b) {
  var name = b.n;
  this.brand = b;
  this.series = b.series && b.series.length ? b.series[0].n : '';
  var chips = this.brands.querySelectorAll('[data-kw-brand]');
  for (var i = 0; i < chips.length; i++) chips[i].classList.toggle('is-active', String(ga(chips[i], 'data-kw-brand')).toLowerCase() === String(name).toLowerCase());
  this.renderPanel();
  this.panel.hidden = false;
  this.panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
};

P.closePanel = function () {
  this.panel.hidden = true; this.panel.innerHTML = ''; this.brand = null;
  var chips = this.brands.querySelectorAll('.is-active');
  for (var i = 0; i < chips.length; i++) chips[i].classList.remove('is-active');
};

P.renderPanel = function () {
  var b = this.brand, t = this.t, self = this, sel = this.series, series = b.series || [];
  var ser = series.filter(function (s) { return s.n === sel; })[0] || series[0];
  var html = '<div class="kwdp__panel-head"><button type="button" class="kwdp__back" data-kw-act="back">' + esc(t.back) + '</button>' +
    '<nav class="kwdp__crumb" aria-label="Breadcrumb"><span>' + esc(b.n) + '</span>' +
    (ser && ser.n ? '<span>' + esc(ser.n) + '</span>' : '') + '</nav></div>';
  if (series.length > 1 || (ser && ser.n)) {
    html += '<div class="kwdp__series" role="tablist" aria-label="' + esc(t.pickSeries) + '">';
    series.forEach(function (s) {
      var on = s === ser;
      html += '<button type="button" role="tab" class="kwdp__series-tab' + (on ? ' is-active' : '') + '" aria-selected="' + on +
        '" data-kw-act="series" data-kw-v="' + esc(s.n) + '">' + esc(s.n || t.all) + '</button>';
    });
    html += '</div>';
  }
  html += '<ul class="kwdp__models" role="list">';
  (ser ? ser.models : []).forEach(function (m) {
    var ix = self.index.filter(function (x) { return x.u === m.u && x.n === m.n; })[0];
    if (ix) html += '<li>' + link('kwdp__model', ix, 'model') + esc(m.n) + '</a></li>';
  });
  this.panel.innerHTML = html + '</ul>';
};

P.showRemembered = function () {
  var d = readDevice(), t = this.t;
  if (!d) return;
  this.rem.innerHTML = '<span class="kwdp__rem-label">' + esc(t.yourDevice) + '</span> <strong>' + esc(d.n) + '</strong>' +
    '<a class="kwdp__rem-link" href="' + esc(d.u) + '" data-kw-act="go">' + esc(t.viewCases) + '</a>' +
    '<button type="button" class="kwdp__rem-change" data-kw-act="forget">' + esc(t.change) + '</button>';
  this.rem.hidden = false;
};

P.matchModel = function (str) {
  var s = norm(str.split('/')[0]), idx = this.index, i;
  if (s.length < 3) return null;
  for (i = 0; i < idx.length; i++) if (idx[i].nn === s || idx[i].an.indexOf(s) > -1) return idx[i];
  for (i = 0; i < idx.length; i++) if (idx[i].an.some(function (a) { return a.length > 3 && (s.indexOf(a) > -1 || a.indexOf(s) > -1); })) return idx[i];
  return null;
};

P.detectModel = function (cb) {
  var self = this;
  if (!this.data) return cb(null);
  var uad = navigator.userAgentData, p = null;
  if (uad && typeof uad.getHighEntropyValues === 'function') {
    try { p = uad.getHighEntropyValues(['model']); } catch (e) { p = null; }
  }
  if (p && typeof p.then === 'function') {
    p.then(function (r) {
      var m = r && r.model && self.matchModel(r.model);
      if (m) track('kw_picker_detect_hit', { brand: m.brand, model: m.n, method: 'uach' });
      cb(m ? { m: m } : null);
    }).catch(function () { cb(null); });
    return;
  }
  if (!/iPhone/.test(String(navigator.userAgent) + String(navigator.platform))) return cb(null);
  var key;
  try { key = Math.min(screen.width, screen.height) + 'x' + Math.max(screen.width, screen.height) + '@' + Math.round(window.devicePixelRatio || 1); } catch (e) { return cb(null); }
  var list = (IOS[key] || '').split(',').map(function (n) {
    n = norm('iPhone ' + n);
    return n && self.index.filter(function (m) { return m.nn === n; })[0];
  }).filter(Boolean);
  if (!list.length) return cb(null);
  track('kw_picker_detect_hit', { brand: 'Apple', model: list.map(function (m) { return m.n; }).join('|'), method: 'ios-screen' });
  cb({ list: list });
};

P.runDetection = function () {
  var box = this.det, t = this.t;
  if (!this.detect || this.mode === 'header' || !this.data || readDevice() || ga(box, 'data-done')) return;
  box.setAttribute('data-done', '1');
  var show = function (html) { box.innerHTML = html + '<button type="button" class="kwdp__det-no" data-kw-act="other">' + esc(t.other) + '</button></span>'; box.hidden = false; };
  this.detectModel(function (r) {
    if (!r) return;
    if (r.m) {
      show('<span class="kwdp__det-label">' + esc(t.detected) + ' <strong>' + esc(r.m.n) + '</strong> ' + esc(t.isThat) + '</span><span class="kwdp__det-actions">' +
        link('kwdp__det-yes', r.m, 'model') + esc(t.yes) + '</a>');
      return;
    }
    var html = '<span class="kwdp__det-label">' + esc(t.whichIphone) + '</span><span class="kwdp__det-actions">';
    r.list.forEach(function (m) { html += link('kwdp__det-opt', m, 'model') + esc(m.n) + '</a>'; });
    show(html);
  });
};

/* ------------------------------------------------------------------ header button */

function Header(root) {
  var self = this;
  this.root = root;
  this.q = function (sel) { return root.querySelector(sel); };
  this.btn = this.q('.kwdb__btn');
  this.bubble = this.q('[data-kw-bubble]');
  this.overlay = this.q('[data-kw-overlay]');
  this.sheet = this.q('[data-kw-sheet]');
  this.title = this.q('[data-kw-sheet-title]');
  this.state = this.q('[data-kw-device-state]');
  this.wrap = this.q('[data-kw-picker-wrap]');
  this.dot = this.q('[data-kw-dot]');
  var pr = this.q('[data-kw-picker]');
  this.picker = pr.kwPicker || (pr.kwPicker = new Picker(pr));
  this.t = this.picker.t;
  this.open = false;
  /* Move the sheet + overlay to <body>: header.liquid styles every button/input inside .header__search-bar. */
  try { document.body.appendChild(this.overlay); document.body.appendChild(this.sheet); } catch (e) {}
  root.addEventListener('click', function (e) { self.onClick(e); });
  this.sheet.addEventListener('click', function (e) { self.onClick(e); });
  this.overlay.addEventListener('click', function () { self.close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.open) self.close(); });
  window.addEventListener('resize', function () { if (self.open) self.place(); });
  this.init();
}
var H = Header.prototype;

H.onClick = function (e) {
  var el = e.target.closest('[data-kw-open],[data-kw-close],[data-kw-bubble-close],[data-kw-hact]');
  if (!el) return;
  if (el.hasAttribute('data-kw-open')) { this.hideBubble(); return this.open ? this.close() : this.show(); }
  if (el.hasAttribute('data-kw-close')) return this.close();
  if (el.hasAttribute('data-kw-bubble-close')) return this.hideBubble();
  var act = ga(el, 'data-kw-hact');
  if (act === 'pick') { e.preventDefault(); return this.showPicker(); }
  if (act === 'go' && this.current) return remember(this.current, this.method || 'remembered');
  if (act === 'feat') { track('kw_picker_feat_click', { href: ga(el, 'href') }); return; }
  if (act === 'choose') { var m = this.list && this.list[+ga(el, 'data-kw-v')]; if (m) remember(m, 'detect'); }
};

H.init = function () {
  var self = this, d = readDevice(), seen = false;
  try { seen = sessionStorage.getItem('kw_bubble') === '1'; } catch (e) {}
  if (d) {
    this.dot.hidden = false; this.current = d; this.method = 'remembered';
    this.renderState('device', d);
    if (!seen) this.showBubble(this.t.yourDevice, d.n); /* once per session, like the detection bubble */
    return;
  }
  /* Eager detection only where the browser can name the device (Chromium Android). iPhone waits for a tap. */
  var uad = navigator.userAgentData;
  if (!this.picker.detect || !uad || typeof uad.getHighEntropyValues !== 'function') return;
  if (seen) return;
  this.picker.onReady(function () {
    self.picker.detectModel(function (r) {
      if (!r || !r.m) return;
      self.current = r.m; self.method = 'detect';
      self.renderState('detected', r.m);
      self.showBubble(self.t.modelDetected + ':', r.m.n);
    });
  });
};

H.showBubble = function (label, name) {
  var self = this;
  this.q('[data-kw-bubble-label]').textContent = label;
  this.q('[data-kw-bubble-name]').textContent = name;
  this.bubble.hidden = false;
  try { sessionStorage.setItem('kw_bubble', '1'); } catch (e) {}
  clearTimeout(this.bt);
  this.bt = setTimeout(function () { self.hideBubble(); }, 20000);
};
H.hideBubble = function () { clearTimeout(this.bt); this.bubble.hidden = true; };

H.renderState = function (kind, d) {
  var t = this.t, cu = casesUrl(d) || safe(d.u), au = accUrl(d);
  var accLabel = String(t.accFor || '%s').replace('%s', d.n || '');
  var head = kind === 'detected'
    ? '<p class="kwdb__q"><span class="kwdb__q-label">' + esc(t.modelDetected) + ':</span> <strong>' + esc(d.n) + '</strong> ' + esc(t.isThat) + '</p>'
    : '<p class="kwdb__q"><span class="kwdb__q-label">' + esc(t.yourDevice) + '</span> <strong>' + esc(d.n) + '</strong></p>';
  var html = head + '<div class="kwdb__actions">' +
    '<a class="kwdb__cta kwdb__cta--primary" href="' + esc(cu) + '" data-kw-hact="go">' + esc(t.casesFor) + ' ' + esc(d.n) + ' <span aria-hidden="true">→</span></a>';
  if (!d.cat || d.cat === 'smartphone') html += '<div class="kwdb__feat" data-kw-feat-slot hidden></div>';
  if (au && au !== cu) html += '<a class="kwdb__cta" href="' + esc(au) + '" data-kw-hact="go">' + esc(accLabel) + '</a>';
  html += '<button type="button" class="kwdb__cta kwdb__cta--ghost" data-kw-hact="pick">' + esc(kind === 'detected' ? t.other : t.changeDevice) + '</button></div>';
  this.state.innerHTML = html;
  this.state.hidden = false;
  this.wrap.hidden = true;
  this.title.textContent = t.open;
  this.renderFeat();
};

/* Pinned universal accessories (finger holder, ring holder): always visible, never buried in a result list. */
H.renderFeat = function () {
  var self = this, slot = this.state.querySelector('[data-kw-feat-slot]');
  var handles = String(ga(this.root, 'data-kw-feat') || '').split(',').filter(Boolean);
  if (!slot || !handles.length) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  };
  var get = function (h) {
    self.featCache = self.featCache || {};
    if (!self.featCache[h]) self.featCache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); });
    return self.featCache[h].catch(function () { return null; });
  };
  Promise.all(handles.map(get)).then(function (ps) {
    ps = ps.filter(function (p) { return p && p.available !== false && p.handle; });
    if (!ps.length) return;
    var html = '<p class="kwdb__feat-label">' + esc(ga(self.root, 'data-kw-feat-label') || '') + '</p><div class="kwdb__feat-row">';
    ps.forEach(function (p) {
      var img = p.featured_image ? String(p.featured_image).replace(/^https?:/, '') : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      html += '<a class="kwdb__feat-card" href="' + esc(root + 'products/' + p.handle) + '" data-kw-hact="feat">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="64" height="64" loading="lazy">' : '') +
        '<span class="kwdb__feat-name">' + esc(p.title) + '</span><span class="kwdb__feat-price">' + esc(fmt(p.price)) + '</span></a>';
    });
    slot.innerHTML = html + '</div>';
    slot.hidden = false;
  });
};

H.renderList = function (list) {
  var t = this.t, html = '<p class="kwdb__q">' + esc(t.whichIphone) + '</p><div class="kwdb__actions kwdb__actions--chips">';
  list.forEach(function (m, i) { html += '<a class="kwdb__cta" href="' + esc(casesUrl(m) || m.u) + '" data-kw-hact="choose" data-kw-v="' + i + '">' + esc(m.n) + '</a>'; });
  html += '<button type="button" class="kwdb__cta kwdb__cta--ghost" data-kw-hact="pick">' + esc(t.other) + '</button></div>';
  this.state.innerHTML = html;
  this.state.hidden = false;
  this.wrap.hidden = true;
  this.title.textContent = t.open;
};

H.showPicker = function () {
  this.state.hidden = true;
  this.wrap.hidden = false;
  this.title.textContent = this.t.pickTitle;
  this.picker.load();
  this.place();
  var inp = this.picker.input;
  if (inp && window.innerWidth >= 990) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
};

H.show = function () {
  var self = this;
  this.open = true;
  this.btn.setAttribute('aria-expanded', 'true');
  this.overlay.hidden = false;
  this.sheet.hidden = false;
  document.documentElement.classList.add('kwdb-open');
  track('kw_picker_start', { surface: 'header' });
  if (this.state.hidden && this.wrap.hidden) {
    this.showPicker();
    if (this.picker.detect && !readDevice()) {
      this.picker.onReady(function () {
        if (self.current || self.list || !self.open) return;
        self.picker.detectModel(function (r) {
          if (!r || !self.open) return;
          if (r.m) { self.current = r.m; self.method = 'detect'; self.renderState('detected', r.m); }
          else if (r.list) { self.list = r.list; self.renderList(r.list); }
          self.place();
        });
      });
    }
  }
  this.place();
  var c = this.sheet.querySelector('[data-kw-close]');
  if (c) { try { c.focus({ preventScroll: true }); } catch (e) {} }
};

H.close = function () {
  this.open = false;
  this.btn.setAttribute('aria-expanded', 'false');
  this.overlay.hidden = true;
  this.sheet.hidden = true;
  document.documentElement.classList.remove('kwdb-open');
  if (this.picker.close) this.picker.close();
  try { this.btn.focus({ preventScroll: true }); } catch (e) {}
};

H.place = function () {
  var r = this.btn.getBoundingClientRect(), s = this.sheet.style;
  var top = Math.round(r.bottom + 10);
  s.top = top + 'px';
  s.maxHeight = 'calc(100vh - ' + (top + 12) + 'px)';
  if (window.innerWidth >= 990) { s.left = Math.max(12, Math.round(r.left)) + 'px'; s.right = 'auto'; }
  else { s.left = ''; s.right = ''; }
};

function boot() {
  var heads = document.querySelectorAll('[data-kw-header]');
  for (var h = 0; h < heads.length; h++) if (!heads[h].kwHeader) heads[h].kwHeader = new Header(heads[h]);
  var roots = document.querySelectorAll('[data-kw-picker]');
  for (var i = 0; i < roots.length; i++) if (!roots[i].kwPicker) roots[i].kwPicker = new Picker(roots[i]);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
